import React  from "react";
import PropTypes from "prop-types";

import Slider from "@material-ui/core/Slider";
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';


const muiTheme = createTheme({
    
    overrides: {
        MuiSlider: {
            thumb: {
                color: "white",
            },
            track: {
                color: 'blue'
            },
            rail: {
                color: 'black',
            }
        },
        
    },
    typography: {
        fontFamily: 'Objective-Regular',
        fontSize: 20,
    },
    palette: {
        text: {
            primary: 'black',
            secondary: 'black',
            disabled: 'grey'
        }
    }

});


function valuetext(value) {
    return `${value}`;
}


function calcScale(min, max, isCelcius) {
    let pos = min;

    let scale = [];
    //let scaleInc =  isCelcius ? 
    //    (max - min <= 20) ? (max - min <= 5) ? 0.5 : 2 : 5
    //   : (max - min <= 60) ? (max - min <= 20) ? 2 : 5 : 10;
    let scaleInc = 25;  // IND range is -20 to + 500 celsius
    while (pos < max) {
        scale.push({ value: pos, label: pos.toFixed(1) });
        if (pos + scaleInc <= max) {
            pos = pos + scaleInc;
        } else {
            pos = max;
            scale.push({ value: pos, label: pos.toFixed(1) });
        }
        //console.log(scale);
    }
    return scale;
}



const  Thermometer = (props) => {
    const { min, max, range, handleValueChangeMin, handleValueChangeMax, isCelcius } = props;
    const scale = calcScale(min, max, isCelcius);
    const [value, setValue] = React.useState(range);

    const handleValueChange = (event, newValue) => {
        event.preventDefault();
        if (newValue[0] !== value[0]) {
            // call min_value handle from viewer
            handleValueChangeMin(newValue[0]);
        } else {
            // call maxvalue handle from viewer
            handleValueChangeMax(newValue[1]);
        }
        setValue(newValue);
    };


    return (
        <ThemeProvider theme={muiTheme}>
            <Slider
                key={`slider1-${min}-${max}`}
                disabled
                orientation="vertical"                  
                defaultValue={range}
                aria-labelledby="vertical-slider"
                getAriaValueText={valuetext}
                onChange={handleValueChange}               
                step={0.1}
                marks={scale}
                min={min}
                max={max}
            />
        </ThemeProvider>
    );
}

export default Thermometer;

Thermometer.propTypes = {
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    range: PropTypes.array.isRequired,
    isCelcius: PropTypes.bool.isRequired,
}